var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceUserscomponent = function SvgWorkspaceUserscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.585 12c0 2.49-1.995 4.5-4.485 4.5S9.6 14.49 9.6 12s2.01-4.5 4.5-4.5 4.485 2.01 4.485 4.5Zm10.5 2.25c0 2.07-1.665 3.75-3.735 3.75s-3.75-1.68-3.75-3.75c0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.735 1.68 3.735 3.75ZM25.35 21c-2.745 0-8.25 1.38-8.25 4.125V28.5h16.5v-3.375C33.6 22.38 28.095 21 25.35 21ZM3.6 24.75c0-3.495 7.005-5.25 10.5-5.25.99 0 2.25.15 3.555.42-3.06 1.695-3.555 3.93-3.555 5.205V28.5H3.6v-3.75Z",
    fill: "current"
  })));
};
export default SvgWorkspaceUserscomponent;